import store from '../store';

/**
 * Valida si el usuario tiene permiso para realizar una acción
 * @param {string} permisoId Identificador del permiso
 * @returns {boolean} True si el usuario tiene permiso, false en caso contrario
 */
export const tienePermiso = permisoId => {
  return store.getters.getStatusPermission(permisoId);
};

/**
 * Obtiene el valor de un permiso
 * @param {string} permisoId Identificador del permiso
 * @returns {Object} Objeto con el valor del permiso
 */
export const getRolPermiso = permisoId => {
  return store.getters.getStatusPermission(permisoId)
    ? { value: '1' }
    : { value: '0' };
};

export const getRol = valorPermiso => {
  return valorPermiso ? { value: '1' } : { value: '0' };
};

/**
 * Verifica si un nodo del árbol de permisos tiene hijos.
 * @param {Object} nodo - Nodo del árbol.
 * @returns {boolean} True si tiene al menos un hijo.
 */
export const tieneHijos = nodo => nodo.children?.length > 0;
